import { useUser } from "@tm/context-distribution"
import { useState, useEffect, useMemo } from "react"
import _ from "lodash"

export const useUserSettingChanged = (iframeId: string, setLoading: (v: boolean) => void) => {
    const userSettings = useUser()?.userSettings

    const strippedUserSettings = useMemo(
        // Exclude specific settings that are not needed for the iframe
        () => (userSettings ? _.omit(userSettings, ["articleListSettings", "showPurchasePrice", "activeVehicleDataProviders"]) : undefined),
        [userSettings]
    )

    const [localUserSettings, setLocalUserSettings] = useState(strippedUserSettings)

    useEffect(() => {
        if (strippedUserSettings && !_.isEqual(strippedUserSettings, localUserSettings)) {
            setLocalUserSettings(strippedUserSettings)
            const iframe = document.getElementById(iframeId) as HTMLIFrameElement | null

            if (iframe) {
                const url = iframe.src
                iframe.src = url
            }

            setLoading(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iframeId, strippedUserSettings, localUserSettings])
}
